import React, { useState } from 'react';
import { Icon, ListItem, ListItemText, Badge, Box, useTheme } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import WhatsNewModal from './WhatsNewModal';
import { whatsNewItems, getLatestItems } from './whatsNewConfig';
import IntlMessages from '@tenant/utility/IntlMessages';
import { useThemeContext } from '@tenant/utility/AppContextProvider/ThemeContextProvider';
import { Fonts, ThemeMode } from 'constants/AppEnums';

const WhatsNewNavItemDoubleMenu = ({ level = 0 }) => {
  const { themeMode } = useThemeContext();
  const theme = useTheme();
  const [modalOpen, setModalOpen] = useState(false);
  
  // Get items from the last 30 days for the badge count
  const recentItems = getLatestItems().filter(item => {
    const itemDate = new Date(item.date);
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    return itemDate >= thirtyDaysAgo;
  });

  // Inline styles to replace the problematic makeStyles import
  const navItemStyles = {
    height: 40,
    marginTop: 1,
    marginBottom: 1,
    cursor: 'pointer',
    textDecoration: 'none !important',
    borderRadius: '0 30px 30px 0',
    paddingLeft: theme.direction === 'ltr' ? 24 + 23 * level : 12,
    paddingRight: theme.direction === 'rtl' ? 24 + 23 * level : 12,
    position: 'relative',
    '&:hover': {
      backgroundColor: 'transparent',
      '& .nav-item-text': {
        color: themeMode === ThemeMode.LIGHT ? theme.palette.primary.main : '#fff',
      },
      '& .nav-item-icon': {
        color: themeMode === ThemeMode.LIGHT ? theme.palette.primary.main : '#fff',
      },
    },
    '& .nav-item-icon': {
      color: theme.palette.sidebar?.textColor || theme.palette.text.secondary,
      fontSize: 22,
      display: 'block',
    },
    '& .nav-item-text': {
      color: theme.palette.sidebar?.textColor || theme.palette.text.primary,
      fontWeight: Fonts.REGULAR,
      fontSize: 14,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <ListItem
        button
        onClick={handleOpenModal}
        sx={navItemStyles}
        className={clsx('nav-item')}
      >
        <Box component='span' mr={4}>
          <Icon
            className={clsx('nav-item-icon')}
            color='action'
          >
            new_releases
          </Icon>
        </Box>
        <ListItemText
          primary={<IntlMessages id="WhatsNewSection" defaultMessage="What's New" />}
          classes={{ primary: 'nav-item-text' }}
        />
        {recentItems.length > 0 && (
          <Box sx={{ mr: 4.25 }}>
            <Badge 
              badgeContent={recentItems.length} 
              color="error"
              sx={{
                '& .MuiBadge-badge': {
                  fontSize: '0.75rem',
                  minWidth: 18,
                  height: 18,
                  borderRadius: '9px',
                }
              }}
            >
              <Box />
            </Badge>
          </Box>
        )}
      </ListItem>

      <WhatsNewModal 
        open={modalOpen}
        onClose={handleCloseModal}
        items={whatsNewItems}
      />
    </>
  );
};

WhatsNewNavItemDoubleMenu.propTypes = {
  level: PropTypes.number,
};

export default WhatsNewNavItemDoubleMenu;
